export function pluralize(
  count: number | null | undefined,
  singular: string = '',
  plural: string = singular + 's',
): string {
  return count === 1 ? singular : plural;
}
